import React, { useState } from 'react';
import { Calendar, Popover } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import styles from './smallCalendar.module.scss';
import KoIcon from '@kwapio/icons';
import { useParams } from 'react-router';
import { KoLoader, KoText } from 'packages';

dayjs.extend(utc);
dayjs.extend(timezone);

const EngagementCalendar = ({handleSlotClick, value, meetings = [], contnet }) => {
  const [currentValue, setCurrentValue] = useState(() => dayjs(value || new Date()));
  const [popoverDate, setPopoverDate] = useState(null);
  const { eventId, accountId, userId } = useParams();
  const [timeSlots, setTimeSlots] = useState();
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [loader, setLoader] = useState(false);
  const env = process.env.REACT_APP_ENV === 'dev' ? 'dev' : 'api';
  const API_BASE = `https://${env}.kwapio.com/api/v1/events/${accountId}/${eventId}/${userId}`;


  const onSelect = async(date) => {
    const formatted = date.format('YYYY-MM-DD');
    setLoader(true);
    const response = await fetch(`${API_BASE}/${formatted}`).then(res => res.json());
    const eventDetails = response?.eventDetails || [];
    const slots = eventDetails
      .filter(slot => !slot.booked)
      .map(slot => {
        const startMatch = slot.slot.match(/start:(\d{2}:\d{2})/);
        const endMatch = slot.slot.match(/end:(\d{2}:\d{2})/);
        return (startMatch && endMatch)
          ? { start: startMatch[1], end: endMatch[1] }
          : null;
      })
      .filter(Boolean);
    setTimeSlots({ [formatted]: slots });
    setLoader(false);
  };

  const changeMonth = (direction) => {
    const newDate =
      direction === 'prev'
        ? currentValue.subtract(1, 'month')
        : currentValue.add(1, 'month');

    setCurrentValue(newDate);
    onSelect?.(newDate);
  };

  const handleSlot = (date, slot) => {
    setPopoverDate(false);
    handleSlotClick(date, slot );
    setSelectedSlot(slot);
  };


  const headerRender = () => {
    return (
      <div className={styles.headerRender}>
        <div className={styles.nav}>
          <KoIcon name="ArrowLeftOutlined" className={styles.navIcon} onClick={() => changeMonth('prev')} />
        </div>
   
        <span className={styles.monthYear}>
          {currentValue?.format?.('MMM YYYY') || ''}
        </span>
        <div className={styles.nav}>
          <KoIcon name="ArrowRightOutlined" className={styles.navIcon} onClick={() => changeMonth('next')} />
        </div>
      </div>
    );
  };

  const dateFullCellRender = (date) => {
    const isToday = date.isSame(dayjs(), 'day');
    const isSelected = date.isSame(currentValue, 'day');
    const isPast = date.isBefore(dayjs().startOf('day'));

    const cellClass = [
      styles.calendarCell,
      isToday ? styles.today : '',
      isSelected ? styles.selected : '',
      isPast ? styles.disabled : ''
    ].join(' ');

    const cellContent = <div className={cellClass}>{date.date()}</div>;

    const slotsForDate = timeSlots?.[date.format('YYYY-MM-DD')] || [];

    if (isPast) {
      return cellContent;
    }

    return (
      <Popover
        title={
          <div className={styles.popoverTitle}>
            <KoText className={styles.popoverTitleText} text={date.format('DD MMM YYYY')} />
          </div>
        }
        placement="right"
        content={
          <div className={styles.calendarPopover}>
            {loader && <KoLoader />}
            {slotsForDate.length > 0 ? (
              slotsForDate.map((slot, idx) => (
                <div
                  key={idx}
                  onClick={() => handleSlot(date.format('DD MMM YYYY'), slot)}
                  className={`${styles.slotCard} ${
                  selectedSlot?.start === slot.start && selectedSlot?.end === slot.end
                    ? styles.selected
                    : ''
                }`}
                >
                  {dayjs(slot.start, 'HH:mm').format('hh:mma')}
                </div>
              ))
            ) : (
              <div className={styles.noSlots}>No slots</div>
            )}
          </div>
        }
        trigger="click"
        open={popoverDate && popoverDate?.isSame(date, 'day')}
        onOpenChange={(open) => {
          setPopoverDate(open ? date : null);
        }}
      >
        {cellContent}
      </Popover>
    );
  };



  return (
    <div className={styles.wrapper}>
      <Calendar
        className="calendarEngagement"
        fullscreen={false}
        value={currentValue}
        onSelect={(date) => {
          setCurrentValue(date);
          onSelect?.(date);
        }}
        headerRender={headerRender}
        fullCellRender={dateFullCellRender}
        disabledDate={(current) => current && current < dayjs().startOf('day')}

      />
    </div>
  );
};

export default EngagementCalendar;
